import { setupEntryPoint } from './setupEntryPoint';
import App from '@/layouts/candidate/AuthenticationLayout.vue';
import router from '@/routers';

// FontAwesomeの設定を読み込み
import '@fortawesome/fontawesome-free/css/all.min.css';

import '../controllers';

setupEntryPoint(App, router);
